import { ActionsMenu } from 'foundations-components/components/ActionsMenu';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
function makeActionMenuButtonComponent({
  IconAsset,
  defaultTooltip
}) {
  return props => {
    const {
      tooltip,
      disabled,
      onClick,
      'data-test-id': dataTestId
    } = props;
    return /*#__PURE__*/_jsx(UITooltip, {
      title: tooltip || defaultTooltip,
      placement: "bottom",
      children: /*#__PURE__*/_jsx("div", {
        onClick: !disabled ? onClick : undefined,
        "data-test-id": dataTestId,
        children: /*#__PURE__*/_jsx(IconAsset, {
          color: disabled ? 'fill-tertiary-pressed' : 'icon-core-subtle'
        })
      })
    }, dataTestId);
  };
}
export default function ActionMenuButton({
  IconAsset,
  defaultTooltip,
  options,
  'data-test-id': dataTestId
}) {
  const Button = makeActionMenuButtonComponent({
    IconAsset,
    defaultTooltip
  });
  const actionOptions = options.map(({
    label,
    disabled,
    tooltip,
    onClick,
    'data-test-id': optionTestId
  }, index) => {
    return {
      value: index,
      text: '',
      disabled,
      indicator: /*#__PURE__*/_jsx(UITooltip, {
        title: tooltip,
        placement: "right",
        children: /*#__PURE__*/_jsx("div", {
          onClick: !disabled ? onClick : undefined,
          "data-test-id": optionTestId,
          children: label
        })
      }, index)
    };
  });
  if (options.length === 1) {
    const [{
      label,
      onClick,
      disabled,
      tooltip
    }] = options;
    return /*#__PURE__*/_jsx(ActionsMenu, {
      referenceIndicator: /*#__PURE__*/_jsx(Button, {
        onClick: !disabled ? onClick : undefined,
        disabled: disabled,
        tooltip: tooltip || label,
        "data-test-id": dataTestId
      }),
      actions: [],
      use: "unstyled",
      onActionClick: () => {}
    });
  } else {
    return /*#__PURE__*/_jsx(ActionsMenu, {
      referenceIndicator: /*#__PURE__*/_jsx(Button, {
        "data-test-id": dataTestId
      }),
      actions: actionOptions,
      use: "unstyled",
      onActionClick: () => {}
    });
  }
}